import './lib/crypto/pbkdf2';
import './lib/crypto/sha1';

declare global {
  interface Window { PBKDF2: any; }
}

export const hashPassword = (pw: string) => {
  return new Promise((res) => {
    const Pbkdf2 = window.PBKDF2;
    const hash = new Pbkdf2(pw, '..............', 200, 64);
    hash.deriveKey(() => {}, (key: string) => res(key));
  });
}

export const generateSalt = () => {
  return new Promise((res) => {
    const Pbkdf2 = window.PBKDF2;
    const hash = new Pbkdf2(
      Math.random().toString(),
      Math.random().toString(),
      Math.floor(Math.random() * 30), 47);
    hash.deriveKey(() => {}, (salt: string) => res(salt));
  });
}
